/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
export var HandoffMethod;
(function (HandoffMethod) {
    HandoffMethod["DIRECT"] = "DIRECT";
    HandoffMethod["DOORSTEP"] = "DOORSTEP";
})(HandoffMethod || (HandoffMethod = {}));
export var PaymentPlan;
(function (PaymentPlan) {
    PaymentPlan["PAYG"] = "PAYG";
    PaymentPlan["SUBSCRIPTION"] = "SUBSCRIPTION";
})(PaymentPlan || (PaymentPlan = {}));
export var PlanStatus;
(function (PlanStatus) {
    PlanStatus["ACTIVE"] = "ACTIVE";
    PlanStatus["DELINQUENT"] = "DELINQUENT";
})(PlanStatus || (PlanStatus = {}));
export var AddressStatus;
(function (AddressStatus) {
    AddressStatus["ACTIVE"] = "ACTIVE";
    AddressStatus["INACTIVE"] = "INACTIVE";
})(AddressStatus || (AddressStatus = {}));
export var TripType;
(function (TripType) {
    TripType["DROPOFF"] = "DROPOFF";
    TripType["PICKUP"] = "PICKUP";
})(TripType || (TripType = {}));
export var PreviousAddressSource;
(function (PreviousAddressSource) {
    PreviousAddressSource["WILSON"] = "WILSON";
    PreviousAddressSource["CUSTOMER"] = "CUSTOMER";
    PreviousAddressSource["MANIFEST"] = "MANIFEST";
})(PreviousAddressSource || (PreviousAddressSource = {}));
export var TripStatus;
(function (TripStatus) {
    TripStatus["PENDING"] = "PENDING";
    TripStatus["TASK_NOT_CREATED"] = "TASK_NOT_CREATED";
    TripStatus["SCHEDULED"] = "SCHEDULED";
    TripStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TripStatus["COMPLETE"] = "COMPLETE";
    TripStatus["CANCELED"] = "CANCELED";
    TripStatus["FAILED"] = "FAILED";
    TripStatus["DRIVER_LAUNCHED"] = "DRIVER_LAUNCHED";
    TripStatus["PENDING_API"] = "PENDING_API";
    TripStatus["NO_LOCATION"] = "NO_LOCATION";
})(TripStatus || (TripStatus = {}));
export var LabelType;
(function (LabelType) {
    LabelType["PHYSICAL"] = "PHYSICAL";
    LabelType["DIGITAL"] = "DIGITAL";
    LabelType["AMAZON"] = "AMAZON";
    LabelType["CONSOLIDATED"] = "CONSOLIDATED";
})(LabelType || (LabelType = {}));
export var PackageStatus;
(function (PackageStatus) {
    PackageStatus["PENDING"] = "PENDING";
    PackageStatus["RECEIVED"] = "RECEIVED";
    PackageStatus["DELIVERED"] = "DELIVERED";
    PackageStatus["PICKED_UP"] = "PICKED_UP";
    PackageStatus["CANCELED"] = "CANCELED";
    PackageStatus["FAILED"] = "FAILED";
    PackageStatus["DEPARTED"] = "DEPARTED";
    PackageStatus["CONSOLIDATED"] = "CONSOLIDATED";
    PackageStatus["DRIVER_LAUNCHED"] = "DRIVER_LAUNCHED";
    PackageStatus["DRIVER_ARRIVING"] = "DRIVER_ARRIVING";
    PackageStatus["RTS"] = "RTS";
    PackageStatus["DELAYED"] = "DELAYED";
    PackageStatus["IN_CUSTODY"] = "IN_CUSTODY";
    PackageStatus["IN_TRANSIT"] = "IN_TRANSIT";
    PackageStatus["PROBLEM"] = "PROBLEM";
})(PackageStatus || (PackageStatus = {}));
export var PackageCondition;
(function (PackageCondition) {
    PackageCondition["OK"] = "OK";
    PackageCondition["PENDING"] = "PENDING";
    PackageCondition["DAMAGED"] = "DAMAGED";
})(PackageCondition || (PackageCondition = {}));
export var ScanType;
(function (ScanType) {
    ScanType["SORT"] = "SORT";
    ScanType["DROPOFF"] = "DROPOFF";
    ScanType["PICKUP"] = "PICKUP";
    ScanType["INGEST"] = "INGEST";
    ScanType["CARRIER"] = "CARRIER";
    ScanType["DEPARTURE"] = "DEPARTURE";
    ScanType["IN_VEHICLE"] = "IN_VEHICLE";
    ScanType["RECEIVED"] = "RECEIVED";
    ScanType["RETURNED"] = "RETURNED";
    ScanType["EXCEPTION"] = "EXCEPTION";
    ScanType["IN_CUSTODY"] = "IN_CUSTODY";
    ScanType["SECOND_SCAN"] = "SECOND_SCAN";
    ScanType["CONTAINER"] = "CONTAINER";
})(ScanType || (ScanType = {}));
export var AttributeType;
(function (AttributeType) {
    AttributeType["TEXT"] = "TEXT";
    AttributeType["INTEGER"] = "INTEGER";
    AttributeType["DROP_DOWN"] = "DROP_DOWN";
})(AttributeType || (AttributeType = {}));
export var OrderResourceType;
(function (OrderResourceType) {
    OrderResourceType["RETURNMATES"] = "RETURNMATES";
    OrderResourceType["NARVAR"] = "NARVAR";
    OrderResourceType["SHOPIFY"] = "SHOPIFY";
})(OrderResourceType || (OrderResourceType = {}));
export var ZipCodeType;
(function (ZipCodeType) {
    ZipCodeType["UNIQUE"] = "UNIQUE";
    ZipCodeType["PO_BOX"] = "PO_BOX";
    ZipCodeType["STANDARD"] = "STANDARD";
    ZipCodeType["UNKNOWN"] = "UNKNOWN";
    ZipCodeType["MILITARY"] = "MILITARY";
})(ZipCodeType || (ZipCodeType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["FREE"] = "FREE";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatus["PENDING"] = "PENDING";
})(PaymentStatus || (PaymentStatus = {}));
export var VehicleType;
(function (VehicleType) {
    VehicleType["CAR"] = "CAR";
    VehicleType["MOTORCYCLE"] = "MOTORCYCLE";
    VehicleType["BICYCLE"] = "BICYCLE";
    VehicleType["TRUCK"] = "TRUCK";
})(VehicleType || (VehicleType = {}));
export var PackageType;
(function (PackageType) {
    PackageType["DROPOFF"] = "DROPOFF";
    PackageType["PICKUP"] = "PICKUP";
})(PackageType || (PackageType = {}));
export var PackageDelayReasonType;
(function (PackageDelayReasonType) {
    PackageDelayReasonType["LOCATION_UNKNOWN_WAREHOUSE"] = "LOCATION_UNKNOWN_WAREHOUSE";
    PackageDelayReasonType["LOCATION_UNKNOWN_DRIVER"] = "LOCATION_UNKNOWN_DRIVER";
    PackageDelayReasonType["LOST_PACKAGE"] = "LOST_PACKAGE";
    PackageDelayReasonType["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    PackageDelayReasonType["ON_HOLD_CUSTOMER_REQUEST"] = "ON_HOLD_CUSTOMER_REQUEST";
    PackageDelayReasonType["MISDELIVERED"] = "MISDELIVERED";
    PackageDelayReasonType["MISDELIVERED_UNRECOVERABLE"] = "MISDELIVERED_UNRECOVERABLE";
    PackageDelayReasonType["LABEL_ISSUE"] = "LABEL_ISSUE";
    PackageDelayReasonType["INCORRECT_ITEM"] = "INCORRECT_ITEM";
    PackageDelayReasonType["HUB_MISSORT"] = "HUB_MISSORT";
    PackageDelayReasonType["MANIFESTED_BUT_NOT_RECEIVED"] = "MANIFESTED_BUT_NOT_RECEIVED";
})(PackageDelayReasonType || (PackageDelayReasonType = {}));
export var PackageProblemReasonType;
(function (PackageProblemReasonType) {
    PackageProblemReasonType["PACKAGE_LOST"] = "PACKAGE_LOST";
    PackageProblemReasonType["NOT_RECEIVED_WITHIN_WINDOW"] = "NOT_RECEIVED_WITHIN_WINDOW";
    PackageProblemReasonType["INVALID_ADDRESS"] = "INVALID_ADDRESS";
})(PackageProblemReasonType || (PackageProblemReasonType = {}));
export var ClaimReasons;
(function (ClaimReasons) {
    ClaimReasons["DAMAGED_DRIVER"] = "DAMAGED_DRIVER";
    ClaimReasons["LOST_DRIVER"] = "LOST_DRIVER";
    ClaimReasons["MISDELIVERED_ADDRESS"] = "MISDELIVERED_ADDRESS";
    ClaimReasons["MISDELIVERED_UNSAFE"] = "MISDELIVERED_UNSAFE";
    ClaimReasons["MISDELIVERED_IMPROPER_POD"] = "MISDELIVERED_IMPROPER_POD";
    ClaimReasons["DAMAGED_WAREHOUSE"] = "DAMAGED_WAREHOUSE";
    ClaimReasons["LOST_WAREHOUSE"] = "LOST_WAREHOUSE";
    ClaimReasons["DAMAGED_MM"] = "DAMAGED_MM";
    ClaimReasons["LOST_MM"] = "LOST_MM";
})(ClaimReasons || (ClaimReasons = {}));
export var TripVariant;
(function (TripVariant) {
    TripVariant["SELLER_PICKUP"] = "SELLER_PICKUP";
    TripVariant["ORDER_BASED_PICKUP"] = "ORDER_BASED_PICKUP";
    TripVariant["ITEM_BASED_PICKUP"] = "ITEM_BASED_PICKUP";
})(TripVariant || (TripVariant = {}));
export var TripCxlReasonType;
(function (TripCxlReasonType) {
    TripCxlReasonType["NOT_READY"] = "NOT_READY";
    TripCxlReasonType["CUSTOMER_SHIPPED"] = "CUSTOMER_SHIPPED";
    TripCxlReasonType["SCHEDULING_ISSUE"] = "SCHEDULING_ISSUE";
    TripCxlReasonType["RESCHEDULE"] = "RESCHEDULE";
    TripCxlReasonType["KEPT_ITEM"] = "KEPT_ITEM";
    TripCxlReasonType["LATE_ORDER"] = "LATE_ORDER";
    TripCxlReasonType["ALREADY_RECEIVED"] = "ALREADY_RECEIVED";
    TripCxlReasonType["ORDER_CANCELLED"] = "ORDER_CANCELLED";
    TripCxlReasonType["MEMBERSHIP_CANCELLED"] = "MEMBERSHIP_CANCELLED";
    TripCxlReasonType["ONFLEET_DELETION"] = "ONFLEET_DELETION";
    TripCxlReasonType["UNDER"] = "UNDER";
    TripCxlReasonType["RTS_PARTNER"] = "RTS_PARTNER";
    TripCxlReasonType["DUPLICATE"] = "DUPLICATE";
    TripCxlReasonType["SIZE_LIMIT"] = "SIZE_LIMIT";
    TripCxlReasonType["PRICE_ISSUE"] = "PRICE_ISSUE";
    TripCxlReasonType["RTS_UNDELIVERABLE"] = "RTS_UNDELIVERABLE";
    TripCxlReasonType["UNKNOWN"] = "UNKNOWN";
    TripCxlReasonType["MANIFESTED_BUT_NOT_RECEIVED"] = "MANIFESTED_BUT_NOT_RECEIVED";
    TripCxlReasonType["BEANS_DELETION"] = "BEANS_DELETION";
})(TripCxlReasonType || (TripCxlReasonType = {}));
export var TripFailureReasonType;
(function (TripFailureReasonType) {
    TripFailureReasonType["ACCESS_FAILURE"] = "ACCESS_FAILURE";
    TripFailureReasonType["APARTMENT_CLOSED"] = "APARTMENT_CLOSED";
    TripFailureReasonType["BUSINESS_CLOSED"] = "BUSINESS_CLOSED";
    TripFailureReasonType["NO_PACKAGE_FROM_CUSTOMER"] = "NO_PACKAGE_FROM_CUSTOMER";
    TripFailureReasonType["UNABLE_DUE_TO_WEATHER"] = "UNABLE_DUE_TO_WEATHER";
    TripFailureReasonType["DUPLICATE"] = "DUPLICATE";
    TripFailureReasonType["CUSTOMER_UNAVAILABLE"] = "CUSTOMER_UNAVAILABLE";
    TripFailureReasonType["DRIVER_EMERGENCY"] = "DRIVER_EMERGENCY";
    TripFailureReasonType["ROADBLOCK"] = "ROADBLOCK";
    TripFailureReasonType["PACKAGE_NOT_IN_VEHICLE"] = "PACKAGE_NOT_IN_VEHICLE";
    TripFailureReasonType["PACKAGE_SIZE"] = "PACKAGE_SIZE";
    TripFailureReasonType["INSUFFICIENT_PACKAGING"] = "INSUFFICIENT_PACKAGING";
    TripFailureReasonType["OTHER_CARRIER_PICKED_UP"] = "OTHER_CARRIER_PICKED_UP";
    TripFailureReasonType["PACKAGE_STOLEN"] = "PACKAGE_STOLEN";
    TripFailureReasonType["SIGNATURE_REQUIRED"] = "SIGNATURE_REQUIRED";
    TripFailureReasonType["OTHER"] = "OTHER";
})(TripFailureReasonType || (TripFailureReasonType = {}));
export var TripCSATReasonType;
(function (TripCSATReasonType) {
    TripCSATReasonType["DRIVER_WAS_UNPROFESSIONAL"] = "DRIVER_WAS_UNPROFESSIONAL";
    TripCSATReasonType["INSTRUCTIONS_WERE_NOT_FOLLOWED"] = "INSTRUCTIONS_WERE_NOT_FOLLOWED";
    TripCSATReasonType["PACKAGE_IS_MISSING"] = "PACKAGE_IS_MISSING";
    TripCSATReasonType["DELIVERED_TO_WRONG_ADDRESS"] = "DELIVERED_TO_WRONG_ADDRESS";
    TripCSATReasonType["PACKAGE_WAS_DAMAGED"] = "PACKAGE_WAS_DAMAGED";
    TripCSATReasonType["INACCURATE_ETA"] = "INACCURATE_ETA";
    TripCSATReasonType["NEVER_ATTEMPTED"] = "NEVER_ATTEMPTED";
    TripCSATReasonType["WRONG_ITEM_PICKED_UP"] = "WRONG_ITEM_PICKED_UP";
    TripCSATReasonType["DRIVER_WAS_FRIENDLY"] = "DRIVER_WAS_FRIENDLY";
    TripCSATReasonType["DRIVER_WENT_ABOVE_AND_BEYOND"] = "DRIVER_WENT_ABOVE_AND_BEYOND";
    TripCSATReasonType["INSTRUCTIONS_WERE_FOLLOWED"] = "INSTRUCTIONS_WERE_FOLLOWED";
    TripCSATReasonType["PACKAGE_WAS_HANDLED_WITH_CARE"] = "PACKAGE_WAS_HANDLED_WITH_CARE";
    TripCSATReasonType["DRIVER_WAS_RESPECTFUL_OF_MY_PROPERTY"] = "DRIVER_WAS_RESPECTFUL_OF_MY_PROPERTY";
    TripCSATReasonType["DRIVER_ARRIVED_ON_TIME"] = "DRIVER_ARRIVED_ON_TIME";
    TripCSATReasonType["WRONG_DROPOFF_LOCATION"] = "WRONG_DROPOFF_LOCATION";
    TripCSATReasonType["MISSING_DROPOFF_LOCATION"] = "MISSING_DROPOFF_LOCATION";
    TripCSATReasonType["PACKAGE_LEFT_IN_BAD_SPOT"] = "PACKAGE_LEFT_IN_BAD_SPOT";
    TripCSATReasonType["WRONG_PICKUP_LOCATION"] = "WRONG_PICKUP_LOCATION";
    TripCSATReasonType["DRIVER_WAS_LATE"] = "DRIVER_WAS_LATE";
    TripCSATReasonType["ITEMS_NOT_ALL_COLLECTED"] = "ITEMS_NOT_ALL_COLLECTED";
    TripCSATReasonType["DRIVER_WAS_DISRUPTIVE"] = "DRIVER_WAS_DISRUPTIVE";
    TripCSATReasonType["ITEMS_LEFT_BEHIND"] = "ITEMS_LEFT_BEHIND";
})(TripCSATReasonType || (TripCSATReasonType = {}));
export var TripSuccessReasonType;
(function (TripSuccessReasonType) {
    TripSuccessReasonType["ALL_CUSTOMER_INSTRUCTIONS_FOLLOWED"] = "ALL_CUSTOMER_INSTRUCTIONS_FOLLOWED";
    TripSuccessReasonType["UNABLE_TO_FOLLOW_CUSTOMER_INSTRUCTIONS"] = "UNABLE_TO_FOLLOW_CUSTOMER_INSTRUCTIONS";
    TripSuccessReasonType["NO_CUSTOMER_INSTRUCTIONS_PROVIDED"] = "NO_CUSTOMER_INSTRUCTIONS_PROVIDED";
    TripSuccessReasonType["DEFAULT"] = "DEFAULT";
})(TripSuccessReasonType || (TripSuccessReasonType = {}));
export var TripAuditStatusType;
(function (TripAuditStatusType) {
    TripAuditStatusType["PENDING"] = "PENDING";
    TripAuditStatusType["IN_PROGRESS"] = "IN_PROGRESS";
    TripAuditStatusType["APPROVED"] = "APPROVED";
    TripAuditStatusType["REPORTED"] = "REPORTED";
})(TripAuditStatusType || (TripAuditStatusType = {}));
export var TripAuditReportReasonType;
(function (TripAuditReportReasonType) {
    TripAuditReportReasonType["CANCELED"] = "CANCELED";
    TripAuditReportReasonType["GEOLOCATION_WRONG"] = "GEOLOCATION_WRONG";
    TripAuditReportReasonType["MISDELIVERED_TO_WRONG_ADDRESS"] = "MISDELIVERED_TO_WRONG_ADDRESS";
    TripAuditReportReasonType["MISSING_PHOTO_LABEL"] = "MISSING_PHOTO_LABEL";
    TripAuditReportReasonType["MISSING_PHOTO_PRIMARY_ADDRESS"] = "MISSING_PHOTO_PRIMARY_ADDRESS";
    TripAuditReportReasonType["MISSING_PHOTO_SECONDARY_ADDRESS"] = "MISSING_PHOTO_SECONDARY_ADDRESS";
    TripAuditReportReasonType["RETURN_TO_SENDER"] = "RETURN_TO_SENDER";
    TripAuditReportReasonType["UNCLEAR_DELIVERY"] = "UNCLEAR_DELIVERY";
    TripAuditReportReasonType["UNSAFE_DELIVERY"] = "UNSAFE_DELIVERY";
    TripAuditReportReasonType["MISSING_POD_PHOTO"] = "MISSING_POD_PHOTO";
    TripAuditReportReasonType["DRIVER_DID_NOT_FOLLOW_INSTRUCTIONS"] = "DRIVER_DID_NOT_FOLLOW_INSTRUCTIONS";
    TripAuditReportReasonType["MISSING_FINAL_RESTING_PLACE_PHOTO"] = "MISSING_FINAL_RESTING_PLACE_PHOTO";
    TripAuditReportReasonType["MISSING_HANDOFF_POD"] = "MISSING_HANDOFF_POD";
})(TripAuditReportReasonType || (TripAuditReportReasonType = {}));
export var TripAuditSourceType;
(function (TripAuditSourceType) {
    TripAuditSourceType["WILSON"] = "WILSON";
    TripAuditSourceType["RETOOL"] = "RETOOL";
    TripAuditSourceType["OTHER"] = "OTHER";
})(TripAuditSourceType || (TripAuditSourceType = {}));
export var TripAuditSaverReviewStatusType;
(function (TripAuditSaverReviewStatusType) {
    TripAuditSaverReviewStatusType["PENDING"] = "PENDING";
    TripAuditSaverReviewStatusType["DELIVERED_SUCCESSFULLY"] = "DELIVERED_SUCCESSFULLY";
    TripAuditSaverReviewStatusType["INVALID_FLAG_DELIVERED_SUCCESSFULLY"] = "INVALID_FLAG_DELIVERED_SUCCESSFULLY";
    TripAuditSaverReviewStatusType["NEW_DX_CORRECTED_DELIVERED_SUCCESSFULLY"] = "NEW_DX_CORRECTED_DELIVERED_SUCCESSFULLY";
    TripAuditSaverReviewStatusType["CUSTOMER_RETRIEVED_PACKAGE"] = "CUSTOMER_RETRIEVED_PACKAGE";
    TripAuditSaverReviewStatusType["FAILED_DELIVERY"] = "FAILED_DELIVERY";
    TripAuditSaverReviewStatusType["MISDELIVERED_WRONG_ADDRESS"] = "MISDELIVERED_WRONG_ADDRESS";
    TripAuditSaverReviewStatusType["LOST_CANNOT_BE_SAVED"] = "LOST_CANNOT_BE_SAVED";
    TripAuditSaverReviewStatusType["MIS_SORT"] = "MIS_SORT";
    TripAuditSaverReviewStatusType["CANCELED_RTS"] = "CANCELED_RTS";
    TripAuditSaverReviewStatusType["DRIVER_CORRECTED_DELIVERED_SUCCESSFULLY"] = "DRIVER_CORRECTED_DELIVERED_SUCCESSFULLY";
})(TripAuditSaverReviewStatusType || (TripAuditSaverReviewStatusType = {}));
export var TripAiAuditStatus;
(function (TripAiAuditStatus) {
    TripAiAuditStatus["APPROVED"] = "APPROVED";
    TripAiAuditStatus["REPORTED"] = "REPORTED";
})(TripAiAuditStatus || (TripAiAuditStatus = {}));
export var PushNotificationOsType;
(function (PushNotificationOsType) {
    PushNotificationOsType["IOS"] = "IOS";
    PushNotificationOsType["ANDROID"] = "ANDROID";
    PushNotificationOsType["WEB"] = "WEB";
    PushNotificationOsType["MACOS"] = "MACOS";
    PushNotificationOsType["WINDOWS"] = "WINDOWS";
})(PushNotificationOsType || (PushNotificationOsType = {}));
export var DriverReliabilityStatus;
(function (DriverReliabilityStatus) {
    DriverReliabilityStatus["ARRIVED"] = "ARRIVED";
    DriverReliabilityStatus["LATE_ARRIVAL"] = "LATE_ARRIVAL";
    DriverReliabilityStatus["CALLED_OUT"] = "CALLED_OUT";
    DriverReliabilityStatus["NO_SHOW"] = "NO_SHOW";
    DriverReliabilityStatus["RM_CANCELLATION"] = "RM_CANCELLATION";
    DriverReliabilityStatus["NOT_PREPARED"] = "NOT_PREPARED";
    DriverReliabilityStatus["ROUTE_ABANDONMENT"] = "ROUTE_ABANDONMENT";
    DriverReliabilityStatus["REFUSED_OFFER"] = "REFUSED_OFFER";
    DriverReliabilityStatus["RELEASED_ROUTE"] = "RELEASED_ROUTE";
    DriverReliabilityStatus["DOUBLE_ROUTE"] = "DOUBLE_ROUTE";
    DriverReliabilityStatus["LATE_CANCELLATION"] = "LATE_CANCELLATION";
})(DriverReliabilityStatus || (DriverReliabilityStatus = {}));
export var PartnerUserRole;
(function (PartnerUserRole) {
    PartnerUserRole["ADMIN"] = "ADMIN";
})(PartnerUserRole || (PartnerUserRole = {}));
export var InboxType;
(function (InboxType) {
    InboxType["GMAIL"] = "GMAIL";
})(InboxType || (InboxType = {}));
export var InboxStatus;
(function (InboxStatus) {
    InboxStatus["ACTIVE"] = "ACTIVE";
    InboxStatus["INACTIVE"] = "INACTIVE";
})(InboxStatus || (InboxStatus = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["CANCELED"] = "CANCELED";
    OrderStatus["DELIVERED"] = "DELIVERED";
    OrderStatus["IN_TRANSIT"] = "IN_TRANSIT";
    OrderStatus["PROBLEM"] = "PROBLEM";
    OrderStatus["PROCESSING"] = "PROCESSING";
    OrderStatus["RETURNED"] = "RETURNED";
    OrderStatus["CONFIRMED"] = "CONFIRMED";
})(OrderStatus || (OrderStatus = {}));
export var PolybagErrorType;
(function (PolybagErrorType) {
    PolybagErrorType["DUPLICATE"] = "DUPLICATE";
    PolybagErrorType["NOT_FOUND"] = "NOT_FOUND";
})(PolybagErrorType || (PolybagErrorType = {}));
export var ConsolidationScanType;
(function (ConsolidationScanType) {
    ConsolidationScanType["DROP_OFF"] = "DROP_OFF";
    ConsolidationScanType["RECEIVED"] = "RECEIVED";
    ConsolidationScanType["IN_CUSTODY"] = "IN_CUSTODY";
})(ConsolidationScanType || (ConsolidationScanType = {}));
export var CommType;
(function (CommType) {
    CommType["DELIVERY"] = "DELIVERY";
})(CommType || (CommType = {}));
export var ShopType;
(function (ShopType) {
    ShopType["SHOPIFY"] = "SHOPIFY";
})(ShopType || (ShopType = {}));
export var PartnerUserRoles;
(function (PartnerUserRoles) {
    PartnerUserRoles["ADMIN"] = "ADMIN";
})(PartnerUserRoles || (PartnerUserRoles = {}));
export var ConsolidationStatus;
(function (ConsolidationStatus) {
    ConsolidationStatus["PENDING"] = "PENDING";
    ConsolidationStatus["PACKED"] = "PACKED";
    ConsolidationStatus["DEPARTED"] = "DEPARTED";
    ConsolidationStatus["SHIPPED"] = "SHIPPED";
    ConsolidationStatus["IN_TRANSIT"] = "IN_TRANSIT";
    ConsolidationStatus["RECEIVED"] = "RECEIVED";
    ConsolidationStatus["IN_CUSTODY"] = "IN_CUSTODY";
    ConsolidationStatus["DELAYED_MISSORT"] = "DELAYED_MISSORT";
})(ConsolidationStatus || (ConsolidationStatus = {}));
export var ConsolidationType;
(function (ConsolidationType) {
    ConsolidationType["INBOUND"] = "INBOUND";
    ConsolidationType["OUTBOUND"] = "OUTBOUND";
})(ConsolidationType || (ConsolidationType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["BLOCKER"] = "BLOCKER";
    LocationType["DELIVERY_ZONE"] = "DELIVERY_ZONE";
    LocationType["PROCESSING"] = "PROCESSING";
    LocationType["ROUTE"] = "ROUTE";
    LocationType["STAGING"] = "STAGING";
    LocationType["STORAGE"] = "STORAGE";
})(LocationType || (LocationType = {}));
export var AsyncJobDataType;
(function (AsyncJobDataType) {
    AsyncJobDataType["RESCHEDULE_PACKAGE_ERROR"] = "RESCHEDULE_PACKAGE_ERROR";
    AsyncJobDataType["ON_CONSOLIDATION_SCAN"] = "ON_CONSOLIDATION_SCAN";
    AsyncJobDataType["ON_POLYBAG_SCAN"] = "ON_POLYBAG_SCAN";
    AsyncJobDataType["ON_WORKER_ROUTE_PRICING_CALCULATION"] = "ON_WORKER_ROUTE_PRICING_CALCULATION";
    AsyncJobDataType["ON_WORKER_ROUTE_PRICING_CALCULATION_INITIAL"] = "ON_WORKER_ROUTE_PRICING_CALCULATION_INITIAL";
    AsyncJobDataType["ON_WORKER_ROUTE_UPDATE"] = "ON_WORKER_ROUTE_UPDATE";
    AsyncJobDataType["ON_ROUTE_DRIVER_CLAIM"] = "ON_ROUTE_DRIVER_CLAIM";
    AsyncJobDataType["ON_ROUTES_RELEASE"] = "ON_ROUTES_RELEASE";
    AsyncJobDataType["ON_ROUTE_DRIVER_CLAIM_RELEASE"] = "ON_ROUTE_DRIVER_CLAIM_RELEASE";
})(AsyncJobDataType || (AsyncJobDataType = {}));
export var RouteBookingStatus;
(function (RouteBookingStatus) {
    RouteBookingStatus["PENDING"] = "PENDING";
    RouteBookingStatus["CONFIRMED"] = "CONFIRMED";
    RouteBookingStatus["CANCELED"] = "CANCELED";
    RouteBookingStatus["STANDBY"] = "STANDBY";
    RouteBookingStatus["OFFERED"] = "OFFERED";
})(RouteBookingStatus || (RouteBookingStatus = {}));
export var OrderType;
(function (OrderType) {
    OrderType["ASC"] = "ASC";
    OrderType["DESC"] = "DESC";
})(OrderType || (OrderType = {}));
export var AddressOrderFields;
(function (AddressOrderFields) {
    AddressOrderFields["NAME"] = "NAME";
    AddressOrderFields["CITY"] = "CITY";
    AddressOrderFields["ZIPCODE"] = "ZIPCODE";
    AddressOrderFields["STREET"] = "STREET";
})(AddressOrderFields || (AddressOrderFields = {}));
export var PackageOrderFields;
(function (PackageOrderFields) {
    PackageOrderFields["STATUS"] = "STATUS";
    PackageOrderFields["NAME"] = "NAME";
    PackageOrderFields["RETAILER"] = "RETAILER";
    PackageOrderFields["TRACKING"] = "TRACKING";
    PackageOrderFields["PARTNER"] = "PARTNER";
    PackageOrderFields["DATE"] = "DATE";
    PackageOrderFields["PACKAGE_DATE"] = "PACKAGE_DATE";
    PackageOrderFields["EXPECTED_DATE"] = "EXPECTED_DATE";
    PackageOrderFields["SERVICE_TYPE"] = "SERVICE_TYPE";
    PackageOrderFields["LOCATION_NAME"] = "LOCATION_NAME";
    PackageOrderFields["POLYBAG"] = "POLYBAG";
})(PackageOrderFields || (PackageOrderFields = {}));
export var ServicedZipCodesOrderFields;
(function (ServicedZipCodesOrderFields) {
    ServicedZipCodesOrderFields["ZIPCODE"] = "ZIPCODE";
    ServicedZipCodesOrderFields["ZONE"] = "ZONE";
    ServicedZipCodesOrderFields["COUNTY"] = "COUNTY";
    ServicedZipCodesOrderFields["CITY"] = "CITY";
})(ServicedZipCodesOrderFields || (ServicedZipCodesOrderFields = {}));
export var TripsOrderFields;
(function (TripsOrderFields) {
    TripsOrderFields["DATE"] = "DATE";
    TripsOrderFields["NAME"] = "NAME";
    TripsOrderFields["STATUS"] = "STATUS";
    TripsOrderFields["STREET"] = "STREET";
    TripsOrderFields["PHONE"] = "PHONE";
    TripsOrderFields["PARTNER"] = "PARTNER";
})(TripsOrderFields || (TripsOrderFields = {}));
export var UsersOrderFields;
(function (UsersOrderFields) {
    UsersOrderFields["NAME"] = "NAME";
    UsersOrderFields["PHONE"] = "PHONE";
    UsersOrderFields["EMAIL"] = "EMAIL";
})(UsersOrderFields || (UsersOrderFields = {}));
export var ManifestOrderFields;
(function (ManifestOrderFields) {
    ManifestOrderFields["FILENAME"] = "FILENAME";
    ManifestOrderFields["DATE"] = "DATE";
    ManifestOrderFields["ENTRIES"] = "ENTRIES";
})(ManifestOrderFields || (ManifestOrderFields = {}));
export var NotificationOrderFields;
(function (NotificationOrderFields) {
    NotificationOrderFields["CREATED_AT"] = "CREATED_AT";
    NotificationOrderFields["TEMPLATE_NAME"] = "TEMPLATE_NAME";
})(NotificationOrderFields || (NotificationOrderFields = {}));
export var ConsolidationOrderFields;
(function (ConsolidationOrderFields) {
    ConsolidationOrderFields["STATUS"] = "STATUS";
    ConsolidationOrderFields["ADDRESS"] = "ADDRESS";
    ConsolidationOrderFields["PARTNER"] = "PARTNER";
    ConsolidationOrderFields["TRACKING"] = "TRACKING";
    ConsolidationOrderFields["CREATED_AT"] = "CREATED_AT";
    ConsolidationOrderFields["EXPECTED_DATE"] = "EXPECTED_DATE";
    ConsolidationOrderFields["ID"] = "ID";
    ConsolidationOrderFields["WEIGHT"] = "WEIGHT";
    ConsolidationOrderFields["CARRIER"] = "CARRIER";
    ConsolidationOrderFields["LOCATION_NAME"] = "LOCATION_NAME";
})(ConsolidationOrderFields || (ConsolidationOrderFields = {}));
export var LocationOrderFields;
(function (LocationOrderFields) {
    LocationOrderFields["ID"] = "ID";
    LocationOrderFields["NAME"] = "NAME";
    LocationOrderFields["TYPE"] = "TYPE";
})(LocationOrderFields || (LocationOrderFields = {}));
export var RouteStatus;
(function (RouteStatus) {
    RouteStatus["PENDING"] = "PENDING";
    RouteStatus["IN_PROGRESS"] = "IN_PROGRESS";
    RouteStatus["COMPLETED"] = "COMPLETED";
})(RouteStatus || (RouteStatus = {}));
//# sourceMappingURL=api.js.map